module.exports = __webpack_public_path__ + "img/res9.1bc8d792.gif";